import React from 'react';
import ReactDOM from 'react-dom';
import OnsiteNotifications from './src/components/onsite-notifications';
import urls from './src/data/urls';
import { getTranslations } from './locale-data';
import { IntlProvider } from 'react-intl';

export default function(appNode, locale) {
    ReactDOM.render(
        <IntlProvider locale={normalizeLocaleToPosixFormat(locale)} messages={getTranslations()}>
            <OnsiteNotifications urls={urls} />
        </IntlProvider>,
        appNode
    );
}

function normalizeLocaleToPosixFormat(locale) {
    return locale.replace('_', '-').toLowerCase();
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/index.js